import { Component, OnInit } from '@angular/core';
import { CategoryService, Category } from '../../../services/category.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-categories',
	templateUrl: './categories.component.html',
	styleUrls: ['./categories.component.css']
})
export class CategoriesComponent extends BaseComponent implements OnInit {
	categories:Category[] = [];
	orphans:Category[] = [];

	sub_data  = {};
	cat_assoc = {};

	constructor(
		private categoryService: CategoryService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService
	) {
		super();
	}

	ngOnInit() {
		var self = this;
		this.categoryService.getCategories().subscribe((categories) => {
			self.sub_data = {};
			self.cat_assoc = {};
			self.orphans = [];
			
			this.categories = categories
			.filter((item, index) => {
				if(item.parent_id) {
					if(!self.sub_data[item.parent_id]) {
						self.sub_data[item.parent_id] = [];
					}
					self.sub_data[item.parent_id].push(item);
				}

				self.cat_assoc[item.$key] = item;

				return !item.parent_id;
			})
			// console.log(self.sub_data);

			// get orphan categories
			Object.keys(self.sub_data).forEach((parent_id,i) => {
				if(!self.cat_assoc[parent_id]) {
					self.sub_data[parent_id].forEach((sub, i2) => {
						self.orphans.push(sub)
					})
				}
			})

			// console.log(self.orphans);
		})
	}

	onDeleteClick(key) {
		var self = this;
		if (confirm('Are you sure?')) {
			this.categoryService.deleteCategory(key).then(function(){
				self.notificationsService.error('Deleted', '1 category deleted')
			})
		}
	}

	onSubClick(name) {
		var tr = document.getElementById(name);
		console.log(tr);
		var trClass = tr.className;
		if(trClass == 'hide'){
			tr.className = 'show';
		} else {
			tr.className = 'hide';
		}
	}

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/category/categories/categories.component.ts